import { Action } from '../types/action';

export const doAll =
  (actions: Array<Action>): Action =>
  () =>
    actions.forEach((action) => action());
